import {useEffect, useRef, useState} from "react";
import {findScrollParent} from "../lib/scrollParent.ts";

export const LOAD_MORE_ROOT_MARGIN = '0px 0px 1200px 0px';

interface LoadMoreSentinelOptions {
    hasMore: boolean;
    isLoadingMore: boolean;
    onLoadMore: () => void;
    rootMargin?: string;
}

export function useLoadMoreSentinel({hasMore, isLoadingMore, onLoadMore, rootMargin = LOAD_MORE_ROOT_MARGIN}: LoadMoreSentinelOptions) {
    const [sentinel, setSentinel] = useState<HTMLElement | null>(null);
    const onLoadMoreRef = useRef(onLoadMore);
    onLoadMoreRef.current = onLoadMore;

    useEffect(() => {
        if (!sentinel || !hasMore || isLoadingMore) {
            return;
        }

        const observer = new IntersectionObserver(
            (entries) => {
                if (entries.some(entry => entry.isIntersecting)) {
                    onLoadMoreRef.current();
                }
            },
            {root: findScrollParent(sentinel), rootMargin},
        );
        observer.observe(sentinel);

        return () => observer.disconnect();
    }, [sentinel, hasMore, isLoadingMore, rootMargin]);

    return setSentinel;
}
